import React, { useState } from 'react';
import questions from '../../assets/FAQ/questions.json';
import {Column, Dropdown, DropdownHeader, ArrowDown, ArrowUp, DropdownContent, GridContainer, Section, FaqTitle, FaqText} from './styles'
import faqAuroraImage from '../../assets/FAQ/FAQ_BG.png';
import { FaqAurora } from '../../pages/FAQPage/styles';

type QuestionAnswer = {
  question: string;
  answer: string;
};
  
const DropdownItem: React.FC<{ data: QuestionAnswer }> = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <Dropdown>
      <DropdownHeader onClick={() => setIsOpen(!isOpen)}>
        <b>{data.question}</b>
        {isOpen ? <ArrowUp /> : <ArrowDown />}
      </DropdownHeader>
      <DropdownContent className={isOpen ? 'open' : ''}>
        {data.answer}
      </DropdownContent>
    </Dropdown>
    );
};
  
const FAQ: React.FC = () => {
  const halfLength = Math.ceil(questions.questions.length / 2);

  return (
    <Section id="faq">
      <FaqTitle>FAQs</FaqTitle>
        <FaqAurora src={faqAuroraImage}  alt="faqAurora" />
        <FaqText>Questions? No need to travel far!</FaqText>
        <FaqText>If you've already been accepted and RSVPed, consult your Hacker Guide for more detailed information.</FaqText>
        <GridContainer>
          <Column>
            {questions.questions.slice(0, halfLength).map((qa, index) => (
            <DropdownItem key={index} data={qa} />
            ))}
          </Column>
          <Column>
            {questions.questions.slice(halfLength).map((qa, index) => (
            <DropdownItem key={index + halfLength} data={qa} />
            ))}
          </Column>
        </GridContainer>
    </Section>
    );
}
     
export default FAQ;
